export default __webpack_public_path__ + "static/media/shoelace-logo.6a4024dc.png";